import { useEffect } from 'react';
export const useWatchCookie = (cookieName, callback, fallbackEvent) => {
    useEffect(() => {
        if (!window) {
            return;
        }
        if ('cookieStore' in window) {
            window.cookieStore.addEventListener('change', (event) => {
                if (!event || !event.changed) {
                    return;
                }
                const changedCookieEvent = event.changed.find(cookie => cookie.name === cookieName);
                changedCookieEvent && (callback === null || callback === void 0 ? void 0 : callback(event));
            });
        }
        else {
            window.addEventListener(fallbackEvent, callback);
        }
        return () => {
            if ('cookieStore' in window) {
                window.cookieStore.removeEventListener('change', callback);
            }
            else {
                window.removeEventListener(fallbackEvent, callback);
            }
        };
    }, []);
};
